GP.views.ContentViewerLayout = Backbone.Marionette.LayoutView.extend({
    initialize: function() {
        this.listenTo(GP.vent, 'ContentViewerLayout:refresh_nanoscroller', this.refresh_nanoscroller, this);
        this.listenTo(GP.vent, 'ContentViewerLayout:prev_content', this.prev_content, this);
        this.listenTo(GP.vent, 'ContentViewerLayout:next_content', this.next_content, this);
        this.listenTo(GP.vent, 'ContentViewerLayout:destroy_modal', this.destroy_modal, this);

        if (this.model) {
            this.is_private = (this.model.get('tags').indexOf('PRIVATE') !== -1 || this.model.get('tags').indexOf('PRIVATE_ENFORCED') !== -1);

            // This is to show the placeholder image instead of video if user is in safemode.
            if (this.model.get('type') == 'VIDEO' && this.model.get('placeholder_thumb')) {
                this.model.set('type', 'IMAGE');
            }
        }

        var current_url = (window.location.pathname + window.location.search).toLowerCase();

        this.is_profile = current_url.indexOf('profile') !== -1;
        this.is_home = current_url.indexOf('home') !== -1;
        this.is_trending = current_url.indexOf('trending') !== -1;

        this.show_prev = this.show_prev();
        this.show_next = this.show_next();
    },
    template: function(serialized_data) {
        if (serialized_data.content.content_na) {
            // Show the media not available template
            return template('content-viewer-na', serialized_data);
        } else {
            return template('content-viewer-layout', serialized_data);
        }
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            content: this.model.toJSON()
        };

        // Format to a display-friendly gender (or gender_detail if we have it)
        if (data.content.gender_detail) {
            data.content.gender = _gp_gender_detail_options[data.content.gender_detail];
        } else {
            data.content.gender = _gp_gender_options[data.content.gender];
        }

        data.content.is_profile = this.is_profile;
        data.content.show_prev = this.show_prev;
        data.content.show_next = this.show_next;

        // change videos to the thumbnail if user is unconverted trial (so it doesn't auto play)
        if (
            data.content.duid !== GP.sdata.my_user.duid
            && data.content.type == 'VIDEO'
            && (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE')
        ) {
            data.content.type = 'IMAGE';
            data.content.url = data.content.video_thumb_url;
        }

        // Set the report url
        report_data = {
            reported_duid: this.model.get('duid'),
            reported_from: 'status_update',
            content_id: this.model.get('content_id')
        };
        data.content.report_url = GP.Util.clean_url('/members/user/report_user/', report_data);

        return data;
    },
    templateHelpers: {
        // Check if content-type is text
        content_type_text: function() {
            return (this.content.content_type == 'text');
        },
        content_type_story: function() {
            return (this.content.content_type == 'story');
        },
        content_type_media: function() {
            return (this.content.content_type == 'media');
        },
        content_type_image: function() {
            return (this.content.type == 'IMAGE');
        },
        content_type_video: function() {
            return (this.content.type == 'VIDEO');
        },
        show_video_intro_delete_btn: function() {
            if (this.content.tags.indexOf('VIDEO_INTRO') !== -1) {
                return (this.content.duid == GP.sdata.my_user.duid);
            }
            return false;
        },
        show_content_text: function() {
            return (!_.isEmpty(this.content.caption) || this.content.content_type == 'text');
        },
        show_online_now: function() {
            return (this.content.online_status == 'ONLINE') ? true : false;
        },
        more_comments: function() {
            // Hide 'view more comments' link if showing all comments.
            if (this.content.comments.length >= this.content.comment_count) {
                return false;
            }

            // Show view more link if more than 10 comments on own profile, 5 otherwise.
            return ((this.content.duid == GP.sdata.my_user.duid && this.content.comment_count > 10) || this.content.comment_count > 5);
        },
        show_prev: function() {
            if (this.content.tags.indexOf('VIDEO_INTRO') !== -1) {
                return false;
            }
            return this.content.show_prev;
        },
        show_next: function() {
            if (this.content.tags.indexOf('VIDEO_INTRO') !== -1) {
                return false;
            }
            return this.content.show_next;
        },
        unconverted_trial_user: function() {
            return (GP.sdata.my_user.duid != this.content.duid && GP.sdata.my_user.unconverted_trial && GP.sdata.my_user.membership !== 'PENDING_FREE');
        },
        pending_free_user: function() {
            return (GP.sdata.my_user.duid != this.content.duid && GP.sdata.my_user.membership === 'PENDING_FREE');
        },
        my_profile: function() {
            return (this.content.duid == GP.sdata.my_user.duid);
        },
        blur_image: function() {
            // blur the image if content rating is X
            // user is trial user
            // and variant b in a/b test
            if (typeof self_profile_view != 'undefined' && self_profile_view === true) {
                return false;
            }
            return (this.content.rating == 'X' && GP.sdata.my_user.unconverted_trial);
        },
        is_explicit_locked: function() {
            return this.content.is_locked;
        },
        is_gallery_locked: function() {
            return this.content.is_gallery_locked;
        },
        show_ai_badge: function() {
            return _ai_chatbot_duids.includes(parseInt(this.content.duid));
        },
        show_date_lab_badge: function() {
            return _feedback_user_duids.includes(parseInt(this.content.duid));
        },
        bronze_unlock_explicit_cost: function() {
            return _bronze_unlock_explicit_content_cost;
        }
    },
    regions: {
        countRegion: '.media-count-region',
        commentRegion: '.media-comment-region'
    },
    ui: {
        btn_media_like: '.btn-media-like',
        like_count: '.like-count',
        like_header: '.media-like-header',
        btn_more_comments: '.btn-more-comments',
        btn_comment: '.btn-comment',
        alert_throttled: '.alert-throttled',
        alert_id_throttled: '.alert-id-throttled',
        alert_general_error: '.alert-general-error',
        btn_content_delete: '.btn-content-delete',
        btn_comment_toggle: '.btn-comment-toggle',
        media_comment_input_wrap: '.media-comment-input-wrap',
        btn_comment_options: '.btn-comment-options',
        comment_input: '.comment-textarea',
        comment_container: '.media-comment-region',
        nanoscroller: '#nano-viewer-wrap',
        nano_content: '#nano-viewer-ct',
        media_prev: '.media-prev',
        media_next: '.media-next',
        img_loader: '.img-loader',
        btn_trial_upgrade: '.btn-trial-upgrade',
        btn_pending_free: '.btn-pending-free',
        btn_delete_intro_video: '.btn-delete-intro-video',
        js_content_viewer_unlock: '.js-content-viewer-unlock'
    },
    events: {
        'click @ui.btn_media_like': 'media_like',
        'click @ui.btn_more_comments': 'get_more_comments',
        'click @ui.btn_comment': 'add_comment',
        'keydown @ui.comment_input' : 'input_keydown',
        'keyup @ui.comment_input' : 'check_comment_char',
        'focus @ui.comment_input' : 'comment_input_selected',
        'click @ui.btn_comment_toggle': 'toggle_comment_input',
        'click @ui.btn_comment_options': 'toggle_comment_options',
        'click @ui.media_prev': 'prev_content',
        'click @ui.media_next': 'check_next',
        'click @ui.btn_trial_upgrade': 'redirect_to_trial_upgrade',
        'click @ui.btn_pending_free': 'redirect_to_pending_free',
        'click @ui.btn_delete_intro_video': 'delete_intro_video',
        'click @ui.js_content_viewer_unlock': 'show_unlock_modal'
    },
    onRender: function() {
        var that = this;

        if (this.model.get('tags').indexOf('VIDEO_INTRO') !== -1) {
            $('#fl-modal').addClass('video-intro-modal');
        }
        if (!this.model.get('content_na')) {
            var count_view = new GP.views.ContentCounts({model: this.model});
            this.countRegion.show(count_view);

            // Create comment list view
            var comment_view = new GP.views.CommentList({
                collection: this.model.get('comments'),
                childViewOptions: {
                    parent_model: this.model
                }
            });
            this.commentRegion.show(comment_view);

            if (this.model.get('type') == 'VIDEO' && !this.model.get('is_locked') && !this.model.get('blurred') && MoshPit.get_size() != 'mobile' && !this.model.get('placeholder_thumb')) {
                GP.vent.trigger('Video:setup');
            }

            if (MoshPit.get_size() == 'desktop' || MoshPit.get_size() == 'desktop-wide') {
                this.init_nanoscroller();
            }
        }
        // Format and display timestamp
        jQuery.timeago.settings.strings = GP.Util.configs.timeago;
        this.$el.find('.timeago').timeago();

        if (this.model.has("show_comment_box")) {
            this.show_comment_box();
        }

        if (this.show_prev || this.show_next) {
            $(document).on('keydown.content_arrow', function(e) {
                that.keyboard_arrows(e);
            });
        }

        this.hide_loader();
    },
    modelEvents: {
        'change:like_count': 'update_likes',
        'change:comment_count': 'update_comments',
        'change:comment_throttled_hourly': 'throttled_notice_hourly',
        'change:comment_throttled_daily': 'throttled_notice_daily',
        'change:id_throttled': 'id_throttled_notice',
        'change:general_error': 'general_error',
        'change:has_deleted_comments': 'render'
    },
    input_keydown: function(e) {
        var key = e.which || e.keyCode;
        if (key && key == 13) {
            e.preventDefault();
            this.add_comment(e);
            return;
        }
    },
    comment_input_selected: function() {
        this.ui.media_comment_input_wrap.addClass('input-selected');
    },
    media_like: function(e) {
        e.preventDefault();

        if (this.ui.btn_media_like.hasClass('liked')) {
            this.decrement_likes();
        } else {
            this.increment_likes();
        }
    },
    decrement_likes: function(e) {
        GP.vent.trigger('Content:decrement_likes',  this.model);
    },
    increment_likes: function(e) {
        GP.vent.trigger('Content:increment_likes',  this.model);
    },
    delete_intro_video: function(e) {
        e.preventDefault();
        if (confirm(js_lang.content.confirm_del)) {
            GP.vent.trigger('Content:delete_content', this.model);
        }
    },
    update_likes: function() {
        this.ui.btn_media_like.toggleClass('liked');

        // We need to update the like counts in the trending or profle page after liking in the modal.
        if (this.is_profile) {
            GP.vent.trigger('Content:update_like_count', this.model);
        } else if (this.is_home) {
            GP.vent.trigger('ContentHome:update_like_count', this.model);
        } else if (this.is_trending) {
            GP.vent.trigger('ContentTrending:update_like_count', this.model);
        }
    },
    update_counts: function() {
        // var count_view = new GP.views.ContentCounts({ model: this.model });
        // this.countRegion.show(count_view);
    },
    add_comment: function(e) {
        e.preventDefault();

        var comment_data = {};
        comment_data.model = this.model;
        comment_data.body = this.ui.comment_input.val();
        GP.vent.trigger('Content:add_comment', comment_data);
    },
    update_comments: function() {
        this.ui.comment_input.val('');

        if (this.is_profile) {
            GP.vent.trigger('Content:update_comment_count', this.model);
        } else if (this.is_home) {
            GP.vent.trigger('ContentHome:update_comment_count', this.model);
        } else if (this.is_trending) {
            GP.vent.trigger('ContentTrending:update_comment_count', this.model);
        }
    },
    throttled_notice_hourly: function() {
        this.ui.alert_throttled.addClass('show');
    },
    throttled_notice_daily: function() {
        this.ui.alert_throttled.addClass('show daily');
    },
    id_throttled_notice: function() {
        this.ui.alert_id_throttled.addClass('show');
    },
    general_error: function() {
        this.ui.alert_general_error.addClass('show').text(this.model.get('general_error'));
    },
    get_more_comments: function(e) {
        e.preventDefault();

        GP.vent.trigger('Content:get_more_comments',  this.model, 'content_modal');
    },
    toggle_comment_input: function() {
        if (MoshPit.get_size() == 'mobile') {
            this.ui.media_comment_input_wrap.toggleClass('shown');
        } else {
            this.ui.comment_input.focus();
        }
    },
    toggle_comment_options: function() {
        this.ui.comment_container.toggleClass('show-comment-options');
    },
    init_nanoscroller: function() {
        this.ui.nanoscroller.addClass('nanoscroller nano');
        this.ui.nano_content.addClass('nano-content');
        this.ui.nanoscroller.nanoScroller(GP.Util.configs.nanoScroller);
    },
    refresh_nanoscroller: function() {
        this.ui.nanoscroller.nanoScroller();
    },
    show_comment_box:function() {
        this.toggle_comment_input();
        this.comment_input_selected();

        if (MoshPit.get_size() == 'mobile') {
            this.scroll_to_comment_box();
        }
    },
    scroll_to_comment_box: function() {
        $('.modal-content-viewer').animate({
            'scrollTop': this.ui.media_comment_input_wrap.offset().top
        }, 300);
    },
    check_comment_char: function() {
        var comment_text = $.trim(this.ui.comment_input.val());

        if (comment_text.length === 0) {
            this.ui.btn_comment.addClass('disabled');
        } else {
            this.ui.btn_comment.removeClass('disabled');
        }
    },
    show_prev: function() {
        if (GP.ContentViewer.gallery.is_gallery && this.model) {
            try {
                let current_gallery = this.gallery();
                var first = ((this.gallery && this.gallery().first()) ? this.gallery().first() : null),
                    first_id = ((first && first.get('content_id')) ? first.get('content_id') : null);

                // don't show arrow if there's only one content
                if (current_gallery.length == 1) {
                    return false;
                }

                // show prev button if all content is loaded.
                if (!this.has_more_content()) {
                    return true;
                }

                return (this.model.get('content_id') !== first_id);
            } catch (e) {
                // let's log what the model/gallery objects are if we get an exception
                if (typeof Sentry != 'undefined') {
                    Sentry.captureException(e, {
                        tags: {
                            file:   'ContentViewerLayout',
                            method: 'show_prev'
                        },
                        extra: {
                            gallery: this.gallery,
                            model:   this.model
                        }
                    });
                }
            }
        }

        return false;
    },
    show_next: function() {
        if (GP.ContentViewer.gallery.is_gallery && this.model) {
            try {
                let current_gallery = this.gallery();
                // don't show arrow if there's only one content
                 if (current_gallery.length == 1) {
                    return false;
                 }

                return true;
            } catch (e) {
                // let's log what the model/gallery objects are if we get an exception
                if (typeof Sentry != 'undefined') {
                    Sentry.captureException(e, {
                        tags: {
                            file:   'ContentViewerLayout',
                            method: 'show_next'
                        },
                        extra: {
                            gallery: this.gallery,
                            model:   this.model
                        }
                    });
                }
            }
        }

        return false;
    },
    prev_content: function() {
        if (this.model.get('type') == 'VIDEO') {
            GP.vent.trigger('Video:close');
        }
        GP.vent.trigger('ContentViewer:modal_direction', this.model.get('content_id'), 'prev');
    },
    check_previous: function() {
         let first = ((this.gallery && this.gallery().first()) ? this.gallery().first() : null),
         first_id = ((first && first.get('content_id')) ? first.get('content_id') : null);
         let load_more_trigger = GP.ContentViewer.gallery.load_more_trigger;

         if (this.model.get('content_id') == first_id) {
            GP.vent.trigger(load_more_trigger, 'content_modal_prev');
            this.show_loader();
         } else {
            this.show_loader();
            this.prev_content();
         }
    },
    check_next: function() {
        var last_model = this.gallery().last();
        var load_more_trigger = GP.ContentViewer.gallery.load_more_trigger;

        if (typeof last_model != 'undefined') {
            // check for more content if we've reached the last item.
            if (last_model.get('content_id') == this.model.get('content_id') && this.has_more_content()) {
                this.show_loader();
                GP.vent.trigger(load_more_trigger, 'content_modal');
            } else {
                this.show_loader();
                this.next_content();
            }
        }
    },
    next_content: function() {
        if (this.model.get('type') == 'VIDEO') {
            GP.vent.trigger('Video:close');
        }
        GP.vent.trigger('ContentViewer:modal_direction', this.model.get('content_id'), 'next');
    },
    show_loader: function() {
        this.ui.img_loader.addClass('shown');
    },
    hide_loader: function() {
        this.ui.img_loader.removeClass('shown');
    },
    destroy_modal: function() {
        this.destroy();
        $(document).off('keydown.content_arrow');
    },
    keyboard_arrows: function(e) {
        var key = e.which || e.keyCode;
        if (key && key == 37 && this.show_prev) {
            e.preventDefault();
            this.prev_content();
            return;
        } else if (key && key == 39 && this.show_next) {
            e.preventDefault();
            this.check_next();
            return;
        }
    },
    // Check if more content to load
    has_more_content: function() {
        return GP.reqres.request(GP.ContentViewer.gallery.load_more);
    },
    gallery: function() {
        return GP.reqres.request('ContentViewer:get_gallery_collection');
    },
    redirect_to_trial_upgrade: function() {
        var convert_url = (GP.sdata.my_user.trial_upgrade_url || '/members/billing/convert_trial/');
        window.location.href = convert_url;
    },
    redirect_to_pending_free: function() {
        var convert_url = ('/members/billing/update_cc/');
        window.location.href = convert_url;
    },
    show_unlock_modal: function() {
        GP.vent.trigger('Unlock:show_unlock_modal', this.model.get('duid'));
    }

});








